module.exports = __webpack_public_path__ + "assets/ivory-search.b8528426.svg";